export default {
  'talk.title': 'Πληροφορίες Ομάδας',
  'talk.btn.add': 'Προσθήκη Ομάδας',
  'talk.btn.guard': 'Λήψη φυλάκων',
  'talk.table.name': 'Ονομασία Ομάδας',
  'talk.input.name': 'Παρακαλώ εισάγετε ονομασία ομάδας',
  'talk.download.nodata':
    'Δεν υπάρχει συσκευή για λήψη. Συνδέστε τη συσκευή πριν από τη λήψη των δεδομένων',
};
